// extracted by mini-css-extract-plugin
export default {"nav_icon":"nav_discount_nav_icon__P1dS+","button":"nav_discount_button__g1zzK"};